// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VeeValidate from 'vee-validate'
import { store } from './store/store'
import server from './utils/server'
import VueCookies from 'vue-cookies'
require('es6-promise').polyfill()

Vue.config.productionTip = false

axios.defaults.baseURL = server.baseURL()

/** ONLY FOR TESTING */
// axios.defaults.baseURL = '//mentora-api.101apps.com/'
// axios.defaults.baseURL = '//stage-dmapi-ipl.azurewebsites.net/'

const config = {
  errorBagName: 'errors', // change if property conflicts
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'en',
  dictionary: null,
  strict: true,
  classes: false,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'input|blur',
  inject: true,
  validity: false,
  aria: true,
  i18n: null, // the vue-i18n plugin instance,
  i18nRootKey: 'validations' // the nested key under which the validation messsages will be located
}

/**
 * Use an EventHub so events can be passed between
 * various components and the Store.
 */
const eventHub = new Vue()

/**
 * Add a global mixin to share the EventHub across
 * the entire app and all components.
 */
Vue.mixin({
  data: function () {
    return {
      eventHub: eventHub
    }
  }
})

/**
 * This global filter accepts a string value and shortens it to a specified
 * character length. Also appends '...' at the end.
 *
 * @param {String} original String to shorten.
 * @param {Number} tagetLen Desired number of characters.
 */
/* eslint-disable */
Vue.filter('excerpt', (original, targetLen = 10) => {
  original = _.toString(original)
  targetLen = _.toNumber(targetLen)

  if (!_.isString(original) || !_.isNumber(targetLen)) {
    throw new TypeError(`Please use like so: {{ originalVar | excerpt(50) }}`)
  } else {
    if (original.length <= targetLen) {
      return original
    } else {
      return `${_.trim(original).substring(0, targetLen)}...`
    }
  }
})
/* eslint-enable */

Vue.use(VeeValidate, config)
Vue.use(VueCookies)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js